import { create } from 'zustand';
import type { CashSession, HeartbeatResponse } from '@/lib/types';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface CashState {
  cashSessionId: number | null;
  sessionData: CashSession | null;
  closingPending: boolean;
  isFerme: boolean;
  fermeData: HeartbeatResponse['opening_hours'] | null;

  setCashSession: (id: number, data: CashSession) => void;
  setClosingPending: (pending: boolean, data?: CashSession) => void;
  setFerme: (isFerme: boolean, data?: HeartbeatResponse['opening_hours']) => void;
  clearSession: () => void;
}

// ---------------------------------------------------------------------------
// Defaults
// ---------------------------------------------------------------------------

const DEFAULTS = {
  cashSessionId: null as number | null,
  sessionData: null as CashSession | null,
  closingPending: false,
  isFerme: false,
  fermeData: null as HeartbeatResponse['opening_hours'] | null,
};

// ---------------------------------------------------------------------------
// Store (runtime only — NOT persisted)
// ---------------------------------------------------------------------------

export const useCashStore = create<CashState>()((set) => ({
  ...DEFAULTS,

  setCashSession: (id, data) =>
    set({
      cashSessionId: id,
      sessionData: data,
    }),

  setClosingPending: (pending, data) =>
    set((state) => ({
      closingPending: pending,
      sessionData: data ?? state.sessionData,
    })),

  setFerme: (isFerme, data) =>
    set({
      isFerme,
      fermeData: data ?? null,
    }),

  clearSession: () =>
    set({
      cashSessionId: null,
      sessionData: null,
      closingPending: false,
    }),
}));
